import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { Card } from 'components/@shared/Card';
import { useCallback, useState } from 'react';
import { useDidMount } from 'hooks/useDidMount';
import { useNotifications } from 'hooks/useNotifications';
import { UserProfileForm } from 'components/UserProfile/UserProfileForm/UserProfileForm';
import { BackdropLoader } from 'components/@shared/Loaders';
import { UserFormData } from 'types/user';
import { getUserProfile } from 'services/userService';
import { useActions } from 'store';
import { updateUserProfileAction } from 'store/session/actions';
import { userProfilePageSelector } from './selector';

const cardStyles = {
    maxWidth: '700px',
    margin: 'auto',
};
export const UserProfilePage = () => {
    const { userId, isLoading } = useSelector(userProfilePageSelector);
    const [data, setData] = useState<UserFormData>();
    const [loading, setIsLoading] = useState(false);

    const notifications = useNotifications();
    const actions = useActions({ updateUserProfileAction });

    const updateHandler = useCallback(
        (formData: UserFormData) => {
            if (!userId) {
                return;
            }
            actions.updateUserProfileAction({
                user: formData,
                userId,
                onSuccess: (message) => notifications.show(message),
            });
        },
        [actions, userId],
    );

    useDidMount(() => {
        if (userId) {
            setIsLoading(true);
            getUserProfile(userId)
                .then(setData)
                .finally(() => {
                    setIsLoading(false);
                });
        }
    });

    return (
        <Box width="100%" px={2.5} py={2}>
            <Card title="Personal Info" sx={cardStyles}>
                {data && <UserProfileForm initialData={data} onSubmit={updateHandler} />}
            </Card>
            {(isLoading || loading) && <BackdropLoader />}
        </Box>
    );
};
